import { apiFetch } from "./session";

const API_HOSTS = new Set(
  (process.env.REACT_APP_PROTECTED_API_HOSTS || "")
    .split(",")
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean)
);

const originalFetch = window.fetch.bind(window);

window.fetch = (input, init = {}) => {
  let requestUrl;
  try {
    requestUrl = new URL(input instanceof Request ? input.url : input, window.location.origin);
  } catch {
    return originalFetch(input, init);
  }

  const requestHeaders = new Headers(input instanceof Request ? input.headers : undefined);
  new Headers(init.headers || {}).forEach((value, name) => requestHeaders.set(name, value));
  if (requestHeaders.has("Authorization")) {
    return originalFetch(input, init);
  }

  const isPublicAuthRoute = /(?:^|\/)auth\/(?:login|register|refresh|logout)\/?$/.test(requestUrl.pathname);
  if (API_HOSTS.has(requestUrl.host.toLowerCase()) && !isPublicAuthRoute) {
    return apiFetch(input, init);
  }

  return originalFetch(input, init);
};